<template>
  <div class="discover-monthly">
      <div class="row">
        <div class="col-lg-5">
          <div class="content-left mr-3">
            <div class="content-header">
              #discoverMonthly
            </div>
            <div class="content-title">
              <h1>What to <br> Cook <br> in February</h1>
            </div>
            <div class="content-text">
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolores, assumenda cupiditate? Laborum rem, ipsam rerum doloribus consectetur, quod iste unde ea assumenda neque nostrum hic excepturi a consequuntur ab modi!</p>
            </div>
            <div class="btn content-btn">
              <a href="">Read More <i class="far fa-long-arrow-alt-right"></i> </a>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="content-right">
            <img src="../assets/images/content (6).jpg" alt="" class="content-img w-100">
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
name: 'DiscoverMonth'
}
</script>

<style>

</style>